import React from 'react';
import Geosuggest from 'react-geosuggest';
import GeoSuggestWrapper from '../../../commonComponents/shared/GeoSuggestWrapper';
import { includesObj } from '../../../../lib/utils';
import { Departments } from '../../../../lib/systemVariables';


export default class CityInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            label: '',
            noSuggestionsError: false,
            duplicateError: false,
            invalidAddress: false,
        };
    }

    clearNoSuggestions() {
        if (this.state.noSuggestionsError) this.setState({ noSuggestionsError: false });
    }

    updateSuggestions(suggestions) {
        if (this.state.duplicateError || this.state.invalidAddress) this.setState({ duplicateError: false, invalidAddress: false });
        if (suggestions.length && this.state.label) this.clearNoSuggestions();
    }

    noSuggestions() {
        if (this._geoSuggest.props.value !== '') this.setState({ noSuggestionsError: true });
    }
    
    onSuggestSelect(suggestion) {
        this.setState({ duplicateError: false, invalidAddress: false });
        if (suggestion && suggestion.gmaps && suggestion.gmaps.address_components) {
            const { address_components } = suggestion.gmaps;
            const city = address_components.find(obj => obj.types.includes('locality')) ? address_components.find(obj => obj.types.includes('locality')).long_name : '' || address_components.find(obj => obj.types.includes('sublocality')) ? address_components.find(obj => obj.types.includes('sublocality')).long_name : '';
            const state = address_components.find(obj => obj.types.includes('administrative_area_level_1')) ? address_components.find(obj => obj.types.includes('administrative_area_level_1')).long_name : '';
            const country = address_components.find(obj => obj.types.includes('country')) ? address_components.find(obj => obj.types.includes('country')).long_name : '';
            if (this.props.isIsraeli ? (city && country) : (city && state && country)) {
                if (includesObj({ city, state, country }, [...this.props.values.map(value => ({city: value.city, state: value.state, country: value.country}) ) ] )) {
                    this.setState({ duplicateError: true });
                    return;
                }
                this.props.updateValues([...this.props.values, { city, state, country }]);
                this.setState({ label: '' });
            } else this.setState({ invalidAddress: true });

            this._geoSuggest.blur();
        }
    }

    remove(value) {
        const index = this.props.values.indexOf(value);
        if (index > -1) {
            const values = [...this.props.values];
            values.splice(index, 1);
            this.props.updateValues(values);
        }
    }

    skipSuggest = (suggest) => {
        if(suggest.types.indexOf('locality') < 0 && suggest.types.indexOf('sublocality') < 0) return true;
    }

    render() {
        const requiredErr = this.props.showRequiredError && this.props.required && !this.props.values.length;
        return (
            <div>
                <label className="input-label">Campaign Locations</label>

                <GeoSuggestWrapper isIsraeli={this.props.isIsraeli}>
                    <Geosuggest inputClassName={requiredErr || this.state.invalidAddress ? "error-input" : ""}
                        placeholder="Enter City" queryDelay={0} autoComplete={'on'}
                        ref={el => this._geoSuggest = el} value={this.state.label}
                        onChange={(val) => this.setState({ label: val })}
                        onUpdateSuggests={this.updateSuggestions.bind(this)}
                        initialValue={this.state.label} types={['(regions)']}
                        country={this.props.isIsraeli ? Departments.IL : null} skipSuggest={this.skipSuggest}
                        onFocus={this.clearNoSuggestions.bind(this)} onSuggestSelect={this.onSuggestSelect.bind(this)}
                        onSuggestNoResults={this.noSuggestions.bind(this)} />

                    {!!this.props.values.length && <div className="chip-container">
                        {this.props.values.map((value, index) => {
                            return <div className="chip" key={index}>
                                <span>{value.city}, {value.country === 'United States' ? value.state : value.country}</span>
                                {!value.inUse && <i className="material-icons delete-chip" onClick={this.remove.bind(this, value)}>close</i>}
                            </div>
                        })}
                    </div>}
                </GeoSuggestWrapper>

                {this.state.duplicateError && <span className="error-label">Can not add duplicate city</span>}
                {this.state.invalidAddress && <span className="error-label">Invalid City</span>}
                {this.state.noSuggestionsError && <span className="error-label">No suggestions</span>}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/settingComponents/systemSettings/campaignSettings/CityInput.jsx